var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowToRegIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134-238.5v-49q0-29.5 14.25-44.5T183-357.5q53-27 97.25-39.25T397.5-409q30 0 52 1.75t37 4.75l-23 23.5q-11.47-1.5-29.23-3-17.77-1.5-36.77-1.5-67.5 0-115 13.25t-87 34.25q-21.27 11-28.64 22-7.36 11-7.36 26.5v23.5h232l25 25.5H134Zm473.5 53L508-285l18-18.5 81.5 81.5L808-423l18.5 18.5-219 219Zm-285-356.75Q292-573 292-617t30.75-74.75q30.75-30.75 74.75-30.75t74.75 30.75Q503-661 503-617t-30.75 74.75q-30.75 30.75-75 30.75t-74.75-30.75Zm69 278.25ZM454-560.5q23.5-23.5 23.5-56.5T454-673.5Q430.5-697 397.25-697t-56.5 23.5Q317.5-650 317.5-617t23.25 56.5Q364-537 397.25-537T454-560.5ZM397.5-617Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToRegIcon);
export default __webpack_public_path__ + "static/media/HowToRegIcon.381af92df827ffde848d0af79707d2e2.svg";
export { ForwardRef as ReactComponent };